"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FestivalFormStartCommand = void 0;
class FestivalFormStartCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { step, region_id, region_label, region_detail } = this.input;
        const { gtag: googleAnalyst } = config;
        googleAnalyst('event', 'festival_form_start', {
            step,
            region_id,
            region_label,
            region_detail
        });
        return Promise.resolve();
    }
}
exports.FestivalFormStartCommand = FestivalFormStartCommand;
